import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { trackClick } from '../utils/analytics';

const { FiCoffee, FiZap, FiShoppingCart, FiPlusSquare } = FiIcons;

const actions = [
  { id: 'cafe', label: 'Cafe', icon: FiCoffee, color: 'text-orange-600', bg: 'bg-orange-50' },
  { id: 'gas_station', label: 'Gas', icon: FiZap, color: 'text-amber-600', bg: 'bg-amber-50' },
  { id: 'grocery', label: 'Grocery', icon: FiShoppingCart, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { id: 'pharmacy', label: 'Medicines', icon: FiPlusSquare, color: 'text-rose-600', bg: 'bg-rose-50' }
];

const QuickActions = ({ onSearch, disabled }) => {
  const handleClick = (action) => {
    trackClick(`QuickAction: ${action.label}`, 'Discovery');
    onSearch(action.id);
  };

  return (
    <div className="mb-8 px-2">
      <h4 className="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em] mb-3 ml-1">
        Quick Links
      </h4>
      <div className="grid grid-cols-4 gap-2">
        {actions.map((action) => (
          <button 
            key={action.id} 
            disabled={disabled}
            onClick={() => handleClick(action)}
            className="flex flex-col items-center gap-2 p-3 rounded-2xl bg-white border border-slate-100 high-contrast-shadow hover:border-indigo-600 transition-all active:scale-95 group"
          >
            <div className={`w-10 h-10 ${action.bg} rounded-xl flex items-center justify-center ${action.color} group-hover:scale-110 transition-transform`}>
              <SafeIcon icon={action.icon} className="text-lg" />
            </div>
            <span className="text-[9px] font-black text-slate-900 uppercase tracking-tight">
              {action.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;